document.addEventListener("DOMContentLoaded", function () {
  console.log("bundle");

  const links = document.querySelectorAll(".bundle-link");
  const bundleTitle = document.querySelector(".product-select-bundle");
  if (document.querySelector(".product-select-bundle")) {
    const bundleSection = document.querySelector(".product-select-bundle").parentElement;

    if (!links.length) {
      // If there are no links, hide the entire section
      bundleSection.style.display = "none";
      console.log('no links');
      return;
    }
  
    let checkedLinks = 0; // Counter to track how many links have been checked
    let validLinks = 0;   // Counter to track how many links are valid
  
    links.forEach((link) => {
      fetch(link.href, { method: "HEAD" })
          .then((response) => {
            if (response.ok) {
              validLinks++; // Increment valid links count
              link.style.display = "flex"; // Show the link
              bundleTitle.style.display = "block"; // Show the title
            } else {
              link.style.display = "none"; // Hide the link if it's invalid
            }
          })
          .catch(() => {
            console.error(`Error checking link: ${link.href}`);
            link.style.display = "none"; // Hide the link if there's an error
          })
          .finally(() => {
            checkedLinks++;
            // Once all links are checked
            if (checkedLinks === links.length) {
              // If no valid links, hide the entire section
              if (validLinks === 0) {
                bundleSection.style.display = "none";
              }
            }
          });
    });
  }
});